var map = {
	"./Authorize/modules/AuthorizeReducers": [
		"./src/routes/Authorize/modules/AuthorizeReducers.js",
		"Authorize-modules-AuthorizeReducers"
	],
	"./BookingManagement/modules/BookingManagementReducers": [
		"./src/routes/BookingManagement/modules/BookingManagementReducers.js",
		"BookingManagement-modules-BookingManagementReducers"
	],
	"./CardCheck/modules/CardCheckReducers": [
		"./src/routes/CardCheck/modules/CardCheckReducers.js",
		"CardCheck-modules-CardCheckReducers"
	],
	"./ChangePassword/modules/ChangePasswordReducers": [
		"./src/routes/ChangePassword/modules/ChangePasswordReducers.js",
		"ChangePassword-modules-ChangePasswordReducers"
	],
	"./CreatePayByLinkPlus/modules/CreatePayByLinkPlusReducers": [
		"./src/routes/CreatePayByLinkPlus/modules/CreatePayByLinkPlusReducers.js",
		"CreatePayByLinkPlus-modules-CreatePayByLinkPlusReducers"
	],
	"./Dashboard/modules/DashboardReducers": [
		"./src/routes/Dashboard/modules/DashboardReducers.js",
		"Dashboard-modules-DashboardReducers"
	],
	"./Login/modules/LoginReducers": [
		"./src/routes/Login/modules/LoginReducers.js",
		"Login-modules-LoginReducers"
	],
	"./Moto/modules/MotoReducers": [
		"./src/routes/Moto/modules/MotoReducers.js",
		"Moto-modules-MotoReducers"
	],
	"./OperationManagement/modules/OperationManagementReducers": [
		"./src/routes/OperationManagement/modules/OperationManagementReducers.js",
		"OperationManagement-modules-OperationManagementReducers"
	],
	"./OrderManagement/modules/OrderManagementReducers": [
		"./src/routes/OrderManagement/modules/OrderManagementReducers.js",
		"OrderManagement-modules-OrderManagementReducers"
	],
	"./PayToCard/modules/PayToCardReducers": [
		"./src/routes/PayToCard/modules/PayToCardReducers.js",
		"PayToCard-modules-PayToCardReducers"
	],
	"./PblManagement/modules/PblManagementReducers": [
		"./src/routes/PblManagement/modules/PblManagementReducers.js",
		"PblManagement-modules-PblManagementReducers"
	],
	"./PointsOfSales/modules/PointsOfSalesReducers": [
		"./src/routes/PointsOfSales/modules/PointsOfSalesReducers.js",
		"PointsOfSales-modules-PointsOfSalesReducers"
	],
	"./Profile/modules/ProfileReducers": [
		"./src/routes/Profile/modules/ProfileReducers.js",
		"Profile-modules-ProfileReducers"
	],
	"./RecoveryCredentials/modules/RecoveryCredentialsReducers": [
		"./src/routes/RecoveryCredentials/modules/RecoveryCredentialsReducers.js",
		"RecoveryCredentials-modules-RecoveryCredentialsReducers"
	],
	"./Reports/modules/ReportsReducers": [
		"./src/routes/Reports/modules/ReportsReducers.js",
		"Reports-modules-ReportsReducers"
	],
	"./ResetPassword/modules/ResetPasswordReducers": [
		"./src/routes/ResetPassword/modules/ResetPasswordReducers.js",
		"ResetPassword-modules-ResetPasswordReducers"
	],
	"./SubscriptionPlan/modules/SubscriptionPlanReducers": [
		"./src/routes/SubscriptionPlan/modules/SubscriptionPlanReducers.js",
		"SubscriptionPlan-modules-SubscriptionPlanReducers"
	],
	"./TerminalsManagement/modules/TerminalsManagementReducers": [
		"./src/routes/TerminalsManagement/modules/TerminalsManagementReducers.js",
		"TerminalsManagement-modules-TerminalsManagementReducers"
	],
	"./Users/modules/UsersReducers": [
		"./src/routes/Users/modules/UsersReducers.js",
		"Users-modules-UsersReducers"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/routes lazy recursive ^\\.\\/.*\\/modules\\/.*Reducers$";
module.exports = webpackAsyncContext;